import lobbyWidgetIcon from './percent.webp';

export default {
  lobbyWidgetIcon,
};
